export enum VideoProviderTypes {
  VIMEO = 'vimeo',
  YOUTUBE = 'youtube'
}

export enum MediaPlayerHeights {
  Max
}
